import '../../style';
import './index.less';



// WEBPACK FOOTER //
// ./components/select-item/style/index.tsx